import { Show } from "solid-js";
import Llm from "./Llm";
import { useStateContext } from "../context";

export default function Chatbox() {
    const state = useStateContext();
    return (
        <Show when={state.isChatboxOpen()}>
            <Llm />
        </Show>
    )
}
